import React, { useEffect, useContext, useState, useMemo, useCallback, useRef } from 'react';
import Client from '../../api/client';
import UserContext from '../../business/referential/UserContext';

function CopyrightUpdateWeb({ show, data, websiteId, setShow, successNotif }) {
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const [refresh, setRefresh] = useState(0);
    const [pageId, setPageId] = useState(22);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });
        }
        process();

    }, []);


    const handleChange = (url, row) => {
        row.url = url;
    }

    const saveChanges = () => {
        const process = async () => {
            await Client.updateWebsiteUrls(userData.userObject.id, websiteId, data);
            setRefresh(refresh => refresh + 1);
        }
        process();
        setShow(false);
        successNotif();
    }

    return (<>
        { show &&
            <div className="dashboard-container">
                <h3>
                    {getContent("TitleUpdate")} {getContent("SubTitleUpdate")}
                </h3>
                <div key={refresh} className="overflow-auto" style={{ maxHeight: "420px" }}>
                    <div className="table-row">
                        <p>#</p>
                        <p>{getContent("COL1")}</p>
                    </div>
                    {data && data.length > 0 && <>
                        {data.map((row, index) => {
                            return <div key={index + refresh} className="table-row">
                                <p>{index + 1}</p>
                                <label>
                                    <input type="text" className="table-input" onChange={(e) => handleChange(e.target.value, row)} placeholder="http://www.google.com/" defaultValue={row.url} />
                                </label>
                            </div>
                        })}
                    </>
                    }
                </div>
                <div className="table-row">
                    <a href="/WebsiteListing" className="btn btn-blue mb-4">
                        {getContent("ReturnMenuLink")}
                    </a>
                    <button className="btn btn-blue mb-4" onClick={saveChanges}>
                        {getContent("BtnUpdate")}
                    </button>
                </div>
                <div className="table-row">
                </div>
            </div>
        }
    </>

    );
}

export default CopyrightUpdateWeb;